import { createAsyncThunk } from "@reduxjs/toolkit";
import poolApi from 'api/poolApi';
import { formatQueryParams } from "helpers/format";

export const getPools = createAsyncThunk("Pools", async (params: any = {}) => {
  try {
    const _params: any = {
      cursor: params?.cursor || '',
      limit: Number(params?.limit),
    };
    delete _params.token;
    const response: any = await poolApi.pools(params?.token || 'ttttttttttttttt', formatQueryParams(_params));
    const data = {
      list: response?.data?.pairs || [],
      pagination: {
        total: (Number(response?.data?.pageSize) * Number(Number(response?.data?.page) - 1)) + Number(response?.data?.pairs?.length),
        page: response?.data?.page,
        limit: response?.data?.pageSize,
        cursor: response?.data?.cursor || '',
      }
    };
    return data;
  } catch (error) {
    return error;
  }
});


export const getOptionPools = createAsyncThunk("Option Pools", async (params: any = {}) => {
  try {

    const response: any = await poolApi.optionPools(formatQueryParams(params));
    return response?.data;
  } catch (error) {
    return error;
  }
});


export const getPoolsNormal = async (params: any = {}) => {
  try {
    const _params: any = {
      cursor: params?.cursor || '',
      limit: Number(params?.limit),
    };
    delete _params.token;
    const response: any = await poolApi.pools(params?.token || 'ttttttttttttttt', formatQueryParams(_params));
    const data = {
      list: response?.data?.pairs || [],
      pagination: {
        total: (Number(response?.data?.pageSize) * Number(Number(response?.data?.page) - 1)) + Number(response?.data?.pairs?.length),
        page: response?.data?.page,
        limit: response?.data?.pageSize,
        cursor: response?.data?.cursor || '',
      }
    };
    return data;
  } catch (error) {
    return error;
  }
};

export const postPool = async (data: any = {}) => {
  try {
    const response = await poolApi.postPool(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putPool = async (id: string | number, data: any = {}) => {
  try {
    const response = await poolApi.putPool(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deletePool = async (id: string | number) => {
  try {
    const response = await poolApi.deletePool(id);
    return response;
  } catch (error) {
    return error;
  }
};